import { LayerDefinition } from './types';

export const tropicalDefinition: LayerDefinition = {
  id: 'tropical',
  name: 'Tropical Cyclones & Hazards',
  category: 'extended_climate',
  categoryLabel: 'Extended Climate & Outlooks',
  icon: '🌀',
  description: 'Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.',
  sourceModels: [
    'NOAA National Hurricane Center (NHC)',
    'Central Pacific Hurricane Center (CPHC)',
    'Automated Tropical Cyclone Forecasting (ATCF) System'
  ],
  outputModels: ['NHC Active Tropical Advisory GIS GeoJSON'],
  config: {
    cadence: '15 Minutes (Active Advisories at 03Z, 09Z, 15Z, 21Z & Intermediates)'
  }
};

export default tropicalDefinition;
